import { render } from "./ConfigRadio.vue?vue&type=template&id=94cd9ed0&ts=true"
import script from "./ConfigRadio.vue?vue&type=script&lang=ts"
export * from "./ConfigRadio.vue?vue&type=script&lang=ts"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__